const actionTypes = require('constants/actionTypes');

const fatcaOpenModal = () => ({
    type: actionTypes.FATCA_OPEN_MODAL
});

const fatcaCloseModal = () => ({
    type: actionTypes.FATCA_CLOSE_MODAL
});


module.exports = {
	fatcaOpenModal,
	fatcaCloseModal
}